import type { HTMLAttributes } from 'react';

/**
 * Skeleton primitive — animated grey placeholder used during data loading
 * (Phase 5 Stufe I Slice 8 — Mobile-UX-Polish 2026-05-03).
 *
 * Usage: replace plain "Lädt…" text in list routes with `SkeletonList`
 * to keep the user's mental layout stable while react-query fetches.
 */
export function Skeleton({ className = '', ...rest }: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div
      role="status"
      aria-label="Lädt"
      className={`animate-pulse rounded-md bg-slate-200 ${className}`}
      {...rest}
    />
  );
}

export function SkeletonCard(): JSX.Element {
  return (
    <li className="rounded-lg border border-slate-200 bg-white p-4">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1 space-y-2">
          <Skeleton className="h-4 w-1/3" />
          <Skeleton className="h-3 w-2/3" />
        </div>
        <Skeleton className="h-6 w-20 shrink-0 rounded-md" />
      </div>
    </li>
  );
}

export function SkeletonList({ count = 4 }: { count?: number }): JSX.Element {
  return (
    <ul className="space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </ul>
  );
}
